module.exports = __webpack_public_path__ + "img/termsAndConditions.39ad819c.svg";